import React, { useState, useRef, useEffect } from "react";
import { Container, Image, Dropdown } from 'react-bootstrap';
import './HoverDropDown.scss'
import i18n from 'utils/I18n';

function MenuItem({ item, index, onClick }) {
    return (
        <Dropdown.Item
            href={item.linkTo}
            target={item?.external ? "_blank" : "_self"}
            className={`nav_dropDownMenu_item_container ${item?.customClassName || ''}`}
            rel="noopener noreferrer"
            onClick={() => {
                onClick && onClick()
                item?.onClick && item.onClick()
            }}
            key={`side-menu-${index}`}
            eventKey={item.name}
            active={false}
        >
            <div
                key={`side-menu-${item.name}`}
                className="nav_dropDownMenu_item_container"
            >
                <Container className="nav_dropDownMenu_item">
                    {
                        item.imageUrl && (
                            <Image
                                className="dropDownItem_image"
                                src={item.imageUrl}
                                srcSet={item.src}
                            />
                        )
                    }
                    <div className="dropDownItem_text field-text">
                        {i18n.t(item.name)}
                    </div>
                </Container>
            </div>
        </Dropdown.Item>
    )
}

function HoverDropDown({ menuList, title }) {
    const [show, setShow] = useState(false);
    const timeoutRef = useRef(null);
    const webRef = useRef();

    const handleMouseEnter = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setShow(true);
    };
    const handleMouseLeave = () => {
        timeoutRef.current = setTimeout(() => {
            setShow(false);
        }, 100);
    };

    const handleClickOutside = (event) => {
        if (webRef.current && !webRef.current.contains(event.target)) {
            setShow(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div
            // onMouseEnter={handleMouseEnter}
            // onMouseLeave={handleMouseLeave}
            style={{ display: "inline-block" }}
            className="hover-dropdown"
            ref={webRef}
        >
            <Dropdown show={show}>
                <Dropdown.Toggle
                    variant="primary"
                    className="nav_div text-only-toggle subheading"
                    onClick={()=> setShow(!show)}
                >
                    {title}
                </Dropdown.Toggle>

                <Dropdown.Menu className="nav_web_dropDownMenu field-text">
                    {
                        menuList.map((item, index) => <MenuItem key={'menu_item_' + index} item={item} index={index} onClick={() => setShow(false)} />)
                    }

                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
}

export default HoverDropDown;
